import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, CSSResult } from 'lit'

export const cscActiveFilters = {
  rowGap: css`var(--csc-active-filters-row-gap, ${csSpacing.spacing04})`,
}


export const style: CSSResult = css`
  :host {
    display: contents;
    @media(min-width: ${SCREENS.medium}) {
      --cse-paper-flex-direction: row;
    }
  }

  .mobile {
    display: contents;

    @media(min-width: ${SCREENS.medium}) {
      display: none;
    }
  }

  .desktop {
    display: none;
    gap: 15px;

    @media(min-width: ${SCREENS.medium}) {
      display: contents;
    }
  }

  .filters-group {
    --cse-chip-group-row-gap: ${cscActiveFilters.rowGap};
  }

  .link {
    white-space: nowrap;
    padding-left: ${csSpacing.spacing06};
    margin-left: auto;
    align-self: center;
    text-align: right;
  }

`
